<!--  -->
<template>
  <div class="btnnav" v-show="!btnshow">
    <div :class="item.status == 1?'item nav':'item'" v-for="(item,i) in list" :key="i" @click="check(i)">{{item.name}}</div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      list: [
        {
          name: "初始视角",
          status: 0
        },
        {
          name: "作业模拟",
          status: 1
        },
        {
          name: "停止模拟",
          status: 0
        },
        {
          name: "一键拆分",
          status: 0
        },
        {
          name: "一键组合",
          status: 0
        }
      ]
    };
  },

  props: {
    btnshow: Boolean
  },

  components: {},

  computed: {},

  methods: {
    check(val){
      // this.list[val].status = 1
      document.getElementById("iframe").contentWindow.MMAPI.sencework(val);
      this.list.forEach((item,i) => {
        if(i == val){
          item.status = 1
        }else{
          item.status = 0
        }
      });
    }
  }
};
</script>
<style lang="less" scoped>
.btnnav {
  display: flex;
  position: absolute;
  right: 9vw;
  top: 7.5vh;
  .item {
    width: 92px;
    height: 25px;
    background: url(../../assets/sb/jjbtnbg.png);
    background-size: 100% 100%;
    background-repeat: no-repeat;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    font-size: 14px;
    font-family: "SourceHanSansCN";
    color: rgb(185, 214, 255);
    margin-left: 15px;
  }
  .nav {
    font-size: 14px;
    font-family: "SourceHanSansCN";
    color: rgb(255, 255, 255);
  }
}
</style>